module.exports = __webpack_public_path__ + "static/media/symbol.3c99b898.svg";